import MainLayout from "../components/Layouts/MainLayout";
import EtherScan from "../components/etherScan";

const EtherScanPage = () => {
  return (
    <MainLayout activeId="explorer" isRoomView={true}>
      <EtherScan />
    </MainLayout>
  );
};

export default EtherScanPage;
